import React from 'react';
import { ApolloQueryResult } from '@apollo/client';
import { PaymentMethodsWrapper } from '@css-xp/base/common-tabs/payment-method';
import { generatedTypesNew } from '@css-xp/graphtypes';

interface Props {
  label: string;
  disabled?: boolean;
  transactionAccountId: string;
  invoiceGroupId: string | undefined;
  transactionAccountDisplayName?: string;
  transactionAccountNumber?: string;
  onComplete?: () => Promise<ApolloQueryResult<unknown>>;
  currentTermAccountStatus?: generatedTypesNew.Maybe<string> | undefined;
}

const PaymentMethodsTab = ({
  transactionAccountId,
  invoiceGroupId,
  transactionAccountDisplayName,
  transactionAccountNumber,
  currentTermAccountStatus,
}: Props) => {
  return (
    <PaymentMethodsWrapper
      transactionAccountId={transactionAccountId}
      transactionAccountDisplayName={transactionAccountDisplayName}
      transactionAccountNumber={transactionAccountNumber}
      invoiceGroupId={invoiceGroupId}
      currentTermAccountStatus={currentTermAccountStatus}
    />
  );
};

export default PaymentMethodsTab;
